import apiClient from "./apiClient";

export class OrderTrackingService {
  async getOrders() {
    const response = await apiClient.get("api/orderTracking");
    return response.data;
  }

  async getAuthStatus() {
    const response = await apiClient.get("api/orderTracking/authStatus");
    return response.data;
  }

  async getEBayAuthorizeUrl() {
    const response = await apiClient.get("api/orderTracking/authorize/ebay");
    return response.data;
  }

  async getAcumaticaAuthorizeUrl() {
    const response = await apiClient.get("api/orderTracking/authorize/acumatica");
    return response.data;
  }

  async markBad(orderNbr) {
    const response = await apiClient.post(`api/orderTracking/${encodeURIComponent(orderNbr)}/markBad`);
    return response.data;
  }

  async reset(orderNbr) {
    const response = await apiClient.post(`api/orderTracking/${encodeURIComponent(orderNbr)}/reset`);
    return response.data;
  }
}
